import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Siren } from 'lucide-react';
import { playChime, unlockAudio } from './notifySound';

const API = process.env.REACT_APP_BACKEND_URL;

// Full-screen urgent HR alert; the chime repeats until the employee taps OK
export const UrgentAlertOverlay = ({ token }) => {
  const [alerts, setAlerts] = useState([]);
  const load = useCallback(() => {
    if (!token) return;
    axios.get(`${API}/api/employee-portal/urgent-alerts/pending`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setAlerts(r.data || [])).catch(() => {});
  }, [token]);

  useEffect(() => {
    load();
    const id = setInterval(load, 20000);
    const onMsg = (e) => { if (e.data?.type === 'PUSH_RECEIVED') load(); };
    navigator.serviceWorker?.addEventListener('message', onMsg);
    return () => { clearInterval(id); navigator.serviceWorker?.removeEventListener('message', onMsg); };
  }, [load]);

  const cur = alerts[0];
  useEffect(() => {
    if (!cur) return undefined;
    playChime(true);
    const id = setInterval(() => playChime(true), 3000);
    return () => clearInterval(id);
  }, [cur]);

  if (!cur) return null;
  const ok = async () => {
    unlockAudio();
    await axios.post(`${API}/api/employee-portal/urgent-alerts/${cur.id}/ack`, {}, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
    setAlerts((a) => a.slice(1));
  };
  return (
    <div className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-gradient-to-b from-red-700 to-rose-900 p-6 text-white"
      onPointerDown={unlockAudio} data-testid="urgent-alert-overlay">
      <div className="mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-white/15 animate-pulse">
        <Siren className="h-12 w-12" />
      </div>
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-red-100">Urgent message from HR</p>
      <h1 className="mt-3 text-center text-3xl font-black" data-testid="urgent-alert-title">{cur.title}</h1>
      <p className="mt-4 max-w-md whitespace-pre-line text-center text-base text-red-50" data-testid="urgent-alert-message">{cur.message}</p>
      <p className="mt-4 text-[11px] text-red-200">Sent by {cur.created_by || 'HR'} · {new Date(cur.created_at).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</p>
      <button onClick={ok} className="mt-10 w-full max-w-xs rounded-2xl bg-white py-4 text-lg font-bold text-red-700 shadow-2xl active:scale-95 transition-transform" data-testid="urgent-alert-ok">
        OK, I've read this
      </button>
      {alerts.length > 1 && <p className="mt-3 text-xs text-red-200">{alerts.length - 1} more urgent message(s)</p>}
    </div>
  );
};
